import { defineComponent, onMounted, reactive, ref } from 'vue';
import moment from 'moment';
import StateCard from './StateCard.vue';
import Commercial from './Commercial.vue';
import { useRouter } from 'vue-router';
import { getInlineSoftware } from '@/http/api';
import { htmlRestore } from '@/utils/index';
export default defineComponent({
  name: 'SoftwareCard',
  props: {
    softtwareData: Object
  },
  setup(props, context) {
    const $router = useRouter();
    let onlineState = ref(true);
    const comData = reactive({
      ...props.softtwareData
    });
    // 是否是商包用户
    const userStr = localStorage.getItem('user');
    let tempUser = {};
    if (userStr) {
      tempUser = JSON.parse(userStr);
    }
    const userCommercial = tempUser.isCommercial;
    onMounted(async () => {
      // getInlineSoftware
      const resContrast = await getInlineSoftware({
        software_code: comData.softwareCode
      });
      if (resContrast && resContrast.code == 200 && resContrast.result) {
        var _resContrast$data$;
        onlineState.value = ((_resContrast$data$ = resContrast.data[0]) === null || _resContrast$data$ === void 0 ? void 0 : _resContrast$data$.software_state) || '';
      }
    });
    // const dd = '2022-10-20T12:35:34.000Z';
    // const ss = moment(dd).format('YYYY-MM-DD'); // 2021/10/22
    // const mm = moment(new Date('2022-10-11'))
    //   .add(30, 'days')
    //   .endOf('days')
    //   .fromNow();
    const btnClick = () => {
      // 水滴 主页-软件卡片查看详情点击
      window._sdi.stat({
        ptype: '9',
        stype: '13'
      });
      $router.push({
        path: `/softwaredetails/${comData.softwareId}`
      });
    };
    return {
      comData,
      moment,
      btnClick,
      htmlRestore,
      userCommercial,
      onlineState
    };
  },
  components: {
    StateCard,
    Commercial
  }
});